(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    const shortenVariantLabels = (root = document) => {
    root.querySelectorAll('.variant-picker .variant-option--dropdowns > label, .variant-picker .variant-option--buttons legend').forEach((label) => {
      const text = label.textContent.trim();
      const parentheticalLabel = text.match(/\(([^()]+)\)\s*$/);

      if (parentheticalLabel) {
        label.textContent = parentheticalLabel[1];
      }
    });
  };

  shortenVariantLabels();
  document.addEventListener('shopify:section:load', (event) => shortenVariantLabels(event.target));
  } catch(e) { console.error(e); }
})();

})();
